import * as React from 'react'
import { NextSeo } from 'next-seo'
import styled from 'styled-components'

import * as header from '@ulule/header'
import { SITE_URL } from '@ulule/config'
import * as hooks from '@owl-nest/hooks'
import * as layout from '@owl-nest/layout'
import * as plume from '@ulule/owl-kit-components/next'
import * as shadow from '@owl-nest/shadow'

export default Page

function Page(): React.ReactElement {
  const router = hooks.useNextRouter()

  return (
    <Container>
      <shadow.TrackingProvider
        siteCategory={shadow.SITE.ULULE}
        userLocale={router.locale ?? router.defaultLocale}
        gtmContainerId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER || ''}
      >
        <NextSeo
          title="Visite guidée d'Ulule : crowdfunding, formation, boutique, partenaires"
          description="2mn pour comprendre comment Ulule peut vous aider à travers ses trois métiers : crowdfunding, formation, distribution, pour les particuliers et pour les entreprises"
          openGraph={{
            title: "Visite guidée d'Ulule : crowdfunding, formation, boutique, partenaires",
            description:
              '2mn pour comprendre comment Ulule peut vous aider à travers ses trois métiers : crowdfunding, formation, distribution, pour les particuliers et pour les entreprises',
            images: [
              {
                alt: "Visite guidée d'Ulule : crowdfunding, formation, boutique, partenaires",
                url: `${SITE_URL}/assets/img/common/default-share-image.jpg`,
              },
            ],
          }}
          additionalLinkTags={[
            {
              href: `${SITE_URL}/assets/img/common/favicon-48.png`,
              rel: 'icon',
              sizes: '48x48',
              type: 'image/png',
            },
            {
              href: `${SITE_URL}/assets/img/common/favicon-32.png`,
              rel: 'icon',
              sizes: '32x32',
              type: 'image/png',
            },
          ]}
        />
        <header.Header lang={router.locale} />
        <Main>
          <Iframe
            allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
            src="https://www.videoask.com/fihpir410"
            title="visite"
            width="100%"
          />
        </Main>
        <layout.Footer lang={router.locale} navSections={layout.getNavSectionList(router.locale)} />
      </shadow.TrackingProvider>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const Iframe = styled.iframe`
  border: none;
  overflow: hidden;
  min-height: 600px;
`

const Main = styled.main`
  display: flex;
  flex-grow: 1;
  height: 100%;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    height: calc(100vh - ${plume.SIZES.HEADER_HEIGHT});
  }
`
